import axios, { AxiosRequestConfig } from "axios";
import { BASE_URL } from "./BaseUrl";

export interface requestProps {
  baseUrl?: String;
  contentType?: String;
  token?: String;
  headers?: any;
  AxiosRequestConfig?: AxiosRequestConfig;
}

let request = (options: requestProps = {}) => {
  const { baseUrl = BASE_URL, contentType, token, headers } = options;
  return axios.create({
    baseURL: baseUrl as any,
    // withCredentials: true,

    headers: {
      "Content-Type": contentType ? contentType : "application/json",
      Authorization: `Bearer ${token}`,
      accept: "application/json",
      ...headers,
    },
    ...options?.AxiosRequestConfig,
  });
};
export default request;
